"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var models_1 = require("./models");
var engine_1 = require("./engine");
var comparisonEngine_1 = require("./comparisonEngine");
exports.applyWindow = function (metricTable, dateWindow) {
    if (!dateWindow || dateWindow.unit === models_1.DateTrunc.NONE) {
        return metricTable;
    }
    else if (dateWindow.unit === models_1.DateTrunc.UNKNOWN) {
        return trimMetricTable(metricTable, dateWindow.numberOfUnits);
    }
    else {
        return applyRelativeWindow(metricTable, dateWindow);
    }
};
var trimMetricTable = function (metricTable, numberOfPoints) {
    return metricTable.slice(-numberOfPoints);
};
var applyRelativeWindow = function (metricTable, dateWindow) {
    if (dateWindow.unit === models_1.DateTrunc.NONE || dateWindow.unit === models_1.DateTrunc.UNKNOWN) {
        return metricTable;
    }
    var currentValue = engine_1.getInitialValue(metricTable);
    if (!currentValue) {
        return metricTable;
    }
    var unit = comparisonEngine_1.momentStringFromDateTrunc(dateWindow.unit);
    // Should we also convert this to utc?
    var targetTime = moment.utc(currentValue.timestamp);
    targetTime.subtract(dateWindow.numberOfUnits, unit);
    var targetDate = targetTime.toDate();
    var targetIndex = metricTable.findIndex(function (dataPoint) {
        return dataPoint.timestamp > targetDate;
    });
    return metricTable.slice(targetIndex);
};
exports.ALL_TIME_DATE_WINDOW = { unit: models_1.DateTrunc.NONE, numberOfUnits: 0 };
exports.dateWindowOptions = function (dateTrunc) {
    switch (dateTrunc) {
        case models_1.DateTrunc.SECOND: {
            return [
                { unit: models_1.DateTrunc.MINUTE, numberOfUnits: 3 },
                { unit: models_1.DateTrunc.MINUTE, numberOfUnits: 15 },
                { unit: models_1.DateTrunc.MINUTE, numberOfUnits: 60 },
                exports.ALL_TIME_DATE_WINDOW,
            ];
        }
        case models_1.DateTrunc.MINUTE: {
            return [
                { unit: models_1.DateTrunc.HOUR, numberOfUnits: 3 },
                { unit: models_1.DateTrunc.HOUR, numberOfUnits: 12 },
                { unit: models_1.DateTrunc.HOUR, numberOfUnits: 24 },
                exports.ALL_TIME_DATE_WINDOW,
            ];
        }
        case models_1.DateTrunc.HOUR: {
            return [
                { unit: models_1.DateTrunc.DAY, numberOfUnits: 1 },
                { unit: models_1.DateTrunc.DAY, numberOfUnits: 3 },
                { unit: models_1.DateTrunc.DAY, numberOfUnits: 7 },
                { unit: models_1.DateTrunc.DAY, numberOfUnits: 30 },
                exports.ALL_TIME_DATE_WINDOW,
            ];
        }
        case models_1.DateTrunc.DAY: {
            return [
                { unit: models_1.DateTrunc.DAY, numberOfUnits: 30 },
                { unit: models_1.DateTrunc.DAY, numberOfUnits: 90 },
                { unit: models_1.DateTrunc.DAY, numberOfUnits: 180 },
                { unit: models_1.DateTrunc.DAY, numberOfUnits: 365 },
                exports.ALL_TIME_DATE_WINDOW,
            ];
        }
        case models_1.DateTrunc.WEEK: {
            return [
                { unit: models_1.DateTrunc.WEEK, numberOfUnits: 4 },
                { unit: models_1.DateTrunc.WEEK, numberOfUnits: 12 },
                { unit: models_1.DateTrunc.WEEK, numberOfUnits: 52 },
                exports.ALL_TIME_DATE_WINDOW,
            ];
        }
        case models_1.DateTrunc.MONTH: {
            return [
                { unit: models_1.DateTrunc.MONTH, numberOfUnits: 12 },
                { unit: models_1.DateTrunc.MONTH, numberOfUnits: 60 },
                exports.ALL_TIME_DATE_WINDOW
            ];
        }
        case models_1.DateTrunc.UNKNOWN: {
            return [
                { unit: models_1.DateTrunc.UNKNOWN, numberOfUnits: 30 },
                { unit: models_1.DateTrunc.UNKNOWN, numberOfUnits: 100 },
                { unit: models_1.DateTrunc.UNKNOWN, numberOfUnits: 300 },
                exports.ALL_TIME_DATE_WINDOW,
            ];
        }
        default: {
            return [exports.defaultDateWindow(dateTrunc), exports.defaultDateWindow(models_1.DateTrunc.NONE)];
        }
    }
};
exports.defaultDateWindow = function (dateTrunc) {
    switch (dateTrunc) {
        case models_1.DateTrunc.SECOND: {
            return {
                unit: models_1.DateTrunc.MINUTE,
                numberOfUnits: 3,
            };
        }
        case models_1.DateTrunc.MINUTE: {
            return {
                unit: models_1.DateTrunc.HOUR,
                numberOfUnits: 3,
            };
        }
        case models_1.DateTrunc.HOUR: {
            return {
                unit: models_1.DateTrunc.DAY,
                numberOfUnits: 7,
            };
        }
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY: {
            return {
                unit: models_1.DateTrunc.DAY,
                numberOfUnits: 90,
            };
        }
        case models_1.DateTrunc.MONTH: {
            return {
                unit: models_1.DateTrunc.MONTH,
                numberOfUnits: 12,
            };
        }
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK: {
            return {
                unit: models_1.DateTrunc.WEEK,
                numberOfUnits: 52,
            };
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            return {
                unit: models_1.DateTrunc.QUARTER,
                numberOfUnits: 4,
            };
        }
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR: {
            return {
                unit: models_1.DateTrunc.YEAR,
                numberOfUnits: 5,
            };
        }
        case models_1.DateTrunc.NONE: {
            return exports.ALL_TIME_DATE_WINDOW;
        }
        case models_1.DateTrunc.UNKNOWN:
        case undefined:
        default: {
            return {
                unit: models_1.DateTrunc.UNKNOWN,
                numberOfUnits: 100,
            };
        }
    }
};
exports.defaultNumberOfPoints = function (dateTrunc) {
    switch (dateTrunc) {
        case models_1.DateTrunc.SECOND:
        case models_1.DateTrunc.MINUTE: {
            return 180;
        }
        case models_1.DateTrunc.HOUR: {
            return 72;
        }
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY: {
            return 90;
        }
        case models_1.DateTrunc.MONTH:
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK: {
            return 12;
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            return 4;
        }
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR: {
            return 5;
        }
        case models_1.DateTrunc.UNKNOWN:
        case undefined:
        default: {
            return 100;
        }
    }
};
//# sourceMappingURL=dateWindowEngine.js.map